import { useEffect, RefObject } from 'react';

import { watchBody, watchOnClicks } from '../dom/dom-watcher';

type UseAutoCapturingArgs = {
  rootRef?: RefObject<HTMLElement | null | undefined>;
  enabled?: boolean;
};

export const useAutoCapturing = ({
  rootRef,
  enabled,
}: UseAutoCapturingArgs) => {
  useEffect(() => {
    if (!rootRef?.current || !enabled) {
      return;
    }

    const body = rootRef.current.ownerDocument.body;

    const stopWatchingClicks = watchOnClicks(body);
    const stopWatchingBody = watchBody(body);

    return () => {
      stopWatchingClicks();
      stopWatchingBody();
    };
  }, [rootRef, enabled]);
};
